/// <amd-module name="TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Components/AboutProject/PanelAboutRegion/Interfaces" />
import * as React from "react";
import { ISplitTiming } from "VSS/Platform/Performance";

/**
 * Interface for objects that provide About region (e.g. from contributions)
 */
export interface IProjectAboutRegionProvider {
    /**
     * The getAboutRegion method is used to retrieve the About region to be rendered below the choice group based on
     * the current mode, repoId and it takes a callback to update repoId, if it gets changed inside the provider.
     * markTimeToInteractive is used to mark the TTI when the content is rendered.
     * showError is used to determine if any errors should be shown or not.
     */
    getAboutRegion(
        readMode: boolean,
        repoId: string | undefined,
        repoIdChanged: (id: string) => void,
        markTimeToInteractive: (source: string) => void,
        showError: boolean
    ): JSX.Element;
    /**
     * The getChoiceName method is used to retrieve the name of the choice option. e.g: Wiki, Readme file.
     */
    getChoiceName(): string;
}
